//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** System file types.   */
export const BinaryFiletype = {
    /** The Benevolence Request Document guid */
    BenevolenceRequestDocuments: "2599DDBE-40E1-158E-4436-AACA6C00556E",
    /** Gets the Check-in Label File type guid */
    CheckinLabel: "DE0E5C50-234B-474C-940C-C571F385E65F",
    /** The Communication Attachment file type guid */
    CommunicationAttachment: "10FD7FE8-7187-45CC-A1E7-D9F71BD90E6C",
    /** The Communication Image file type guid */
    CommunicationImage: "60B896C3-F00C-411C-A31C-2D5D4CCBB65F",
    /** The Content Channel Item Image file type guid */
    ContentChannelItemImage: "8DBF874C-F3C2-4848-8137-C963C431EB0B",
    /** Gets the Transaction Image (scanned check, scanned envelope, etc) file type guid */
    ContributionImage: "6D18A9C4-34AB-444A-B95B-C644019465AC",
    /** The Default file type guid */
    Default: "C1142570-8CD6-4A20-83B1-ACB47C1CD377",
    /** The Digitally Signed Document guid */
    DigitallySignedDocuments: "40871411-4E2D-45C2-9E21-D9FCBA5FC340",
    /** The Location Image file type guid */
    LocationImage: "DAB74416-3272-4411-BA69-70944B549A4B",
    /** The Media File file type guid */
    MediaFile: "6CBEA3B0-E983-40C1-9712-BD3FA2466EAE",
    /** The Merge Template file type guid */
    MergeTemplate: "BD63EC0C-2DF8-4C55-97E3-616870C67C59",
    /** The mobile application bundle file type guid */
    MobileAppBundle: "ED456BF6-78F4-4954-9043-CA6849DA2D7E",
    /** The Person Image file type guid */
    PersonImage: "03BD8476-8A9F-4078-B628-5B538F967AFC",
    /** The Signed Document Default File Type */
    SignedDocumentFileType: "8C9C5A97-005A-46E5-AF7B-AC2F359B738A",
};
